export { default as UpDownArrowIcon } from './component';
